// src/App.js
import React, { useState } from 'react';
import './App.css';
import NavBar from './Components/NavBar/NavBar';
import Hero from './Components/Hero/Hero';
import AboutUs from './Components/AboutUs/AboutUs';
import StatStrip from './Components/StatStrip/StatStrip';
import StrideTrack from './Components/EventSchedule/ValorVerticalTimeline';
import MentalHealthDisplayArea from './Components/MentalHealthDisplayArea/ValorMindIntroAssess';
import ValorNextSteps from "./Components/ValorNextSteps/ValorNextSteps";
import ValorFooter from './Components/ValorFooter/ValorFooter';





function App() {


  return (
    <div className='app'>
      <NavBar />
      <Hero />
      <StatStrip
        items={[
          { value: 450, unit: 'k+', label: 'People Reached' },
          { value: 2, unit: '', label: 'Major Runs' },
          { value: 1, unit: '', label: 'Professional Partner' }
        ]}
      />
      <AboutUs />
      <StrideTrack />
      <ValorFooter />

    </div>
  );
}

export default App;
